import React, { Component } from 'react';
import { SUBJECT } from './ContactContainer.js';
import { translate } from 'react-i18next';

class Contact extends Component {
  render() {
    const { t } = this.props;
    return(
      <div className="panel panel-default">
        <div className="panel-heading">
          <h4 className="panel-title">{t('dashboard.contact.heading_contact')}</h4>
        </div>
        <div className="panel-body">
          <form method="post" onSubmit={this.props.handleFormSubmit}>
            <fieldset>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="name">{t('dashboard.contact.label_name')}</label>
                    <input
                      className="form-control"
                      disabled
                      id="name"
                      onChange={this.props.handleNameChange}
                      placeholder={t('dashboard.contact.holder_name')}
                      type="text"
                      value={this.props.name} />
                  </div>
                   <div className="form-group">
                    <label htmlFor="name">{t('dashboard.contact.label_company')}</label>
                    <input
                      className="form-control"
                      id="company"
                      onChange={this.props.handleCompanyChange}
                      placeholder={t('dashboard.contact.holder_company')}
                      type="text"
                      value={this.props.company} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">{t('dashboard.contact.label_email')}</label>
                    <input
                      className="form-control"
                      id="email"
                      onChange={this.props.handleEmailChange}
                      placeholder={t('dashboard.contact.holder_email')}
                      required
                      type="email"
                      value={this.props.email} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">{t('dashboard.contact.label_phone')}</label>
                    <input
                      className="form-control"
                      id="phone"
                      onChange={this.props.handlePhoneChange}
                      placeholder={t('dashboard.contact.holder_phone')}
                      required
                      type="tel"
                      value={this.props.phone} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="subject">{t('dashboard.contact.label_subject')}</label>
                    <select
                      className="form-control"
                      id="subject"
                      onChange={this.props.handleSubjectChange}
                      required
                      value={this.props.subject}>
                      <option value="">{t('dashboard.contact.holder_subject')}</option>
                      <option>{SUBJECT.SALES}</option>
                      <option>{SUBJECT.SERVICE}</option>
                      <option>{SUBJECT.BILLING}</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="message">{t('dashboard.contact.label_message')}</label>
                    <textarea
                      className="form-control"
                      id="message"
                      onChange={this.props.handleMessageChange}
                      placeholder={t('dashboard.contact.holder_message')}
                      required
                      rows="5"
                      value={this.props.message} />
                  </div>
                  <div className="form-group">
                    <button
                      className="btn btn-primary"
                      type="submit">
                      {t('dashboard.contact.btn_submit')}
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    );
  }
}

export default translate('common')(Contact);



// WEBPACK FOOTER //
// ./src/dashboard/contact/Contact.js